import { createContext, useContext } from "react";
import type KeycloakService from "../../utils/auth/keycloakService";
import type { KeycloakAuthState } from "../../utils/auth/keycloakService";

interface KeycloakContextType {
  authState: KeycloakAuthState;
  keycloakService: KeycloakService;
  isInitialized: boolean;
}

export const keycloakContext = createContext<KeycloakContextType | null>(null);

export const useKeycloak = () => {
  const context = useContext(keycloakContext);
  if (!context) {
    throw new Error("useKeycloak must be used within a KeycloakProvider");
  }
  return context;
};
